import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    clear: 'p-2 -mr-2 -my-1',
    input: 'rounded-r-0 h-10',
    submit: 'c-white p-1 rounded-r-xs bg-brand-2 -ml-px',
  },
  defaultSubmitPosition: 'end',
  iconNameClear: 'clear',
  iconNameSubmit: 'search',
  iconSizeClear: 'md',
  iconSizeSubmit: 'md'
} satisfies RecursivePartial<VfConfig['searchBar']>
